import React from "react";
import { MANIFESTO, IMAGES } from "../../lib/site";
import { Reveal } from "../../lib/motion";

export const Manifesto = () => {
  return (
    <section id="craft" className="py-24 md:py-32" data-testid="craft-section">
      <div className="mx-auto max-w-[1400px] px-4 md:px-8 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-5">
            <Reveal>
              <p className="font-body text-xs uppercase tracking-[0.3em] text-[#c96c31] mb-6">
                The Philosophy
              </p>
              <h2 className="font-display font-light leading-[0.95] tracking-tight text-[#2c1e16] text-4xl sm:text-5xl lg:text-6xl">
                Beauty is a<br />
                <span className="italic text-[#c96c31]">discipline.</span>
              </h2>
            </Reveal>
            <Reveal delay={0.15}>
              <div className="arch-frame mt-10 aspect-[3/4] max-w-sm border border-[#2c1e16]/10 overflow-hidden">
                <img
                  src={IMAGES.g2}
                  alt="Boho knotless braids with curly ends"
                  className="h-full w-full object-cover hover:scale-105 transition-transform duration-700"
                />
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-7 lg:pt-16">
            <div className="space-y-14">
              {MANIFESTO.map((m, i) => (
                <Reveal key={m.n} delay={i * 0.1}>
                  <div className="grid grid-cols-[auto_1fr] gap-6 md:gap-10 border-b border-[#2c1e16]/10 pb-10">
                    <span className="font-display text-3xl md:text-4xl text-[#c96c31]/60">{m.n}</span>
                    <div>
                      <h3 className="font-display text-2xl md:text-3xl text-[#2c1e16] mb-3">
                        {m.title}
                      </h3>
                      <p className="font-body text-base md:text-lg text-[#2c1e16]/70 leading-relaxed max-w-xl">
                        {m.body}
                      </p>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
